const PERMISSION_KEY= "community:course_student";
const PAGE_URL = {
    COURSE_STUDENT_PAGE: "/admin/community/course-student"
}

export {PERMISSION_KEY, PAGE_URL}

